import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";

import { StyledDataGrid } from "../../../../common/components/DataGrid/styles";
import { StyledButton } from "../../../../common/components/Button";

export const paymentScheduleOptions = [
  {
    id: 0,
    name: "Before F2F Consult",
  },
  {
    id: 1,
    name: "Before Scanning",
  },
  {
    id: 2,
    name: "Before Designing",
  },
  {
    id: 3,
    name: "Balance Divided By Number of Sets",
  },
  {
    id: 4,
    name: "Balance Divided By Number of Payments",
  },
  {
    id: 5,
    name: "No Payment Required",
  },
];

const paymentTypes = [
  {
    id: 0,
    name: "Online payment",
  },
  {
    id: 1,
    name: "Manually collected",
  },
];

const ShowScheduleDialog = ({
  schedule,
  open,
  onClose,
  isTabBeforeDesign,
  modeOfPayment,
}) => {
  let columns = [
    {
      field: "step",
      headerName: "Payment Schedule",
      flex: 1.3,
      renderCell: (params) => (
        <p>{paymentScheduleOptions.find((o) => o.id === params.value).name}</p>
      ),
    },
    {
      field: "paymentType",
      headerName: "Payment Type",
      flex: 1,
      renderCell: (params) => (
        <p>{paymentTypes.find((p) => p.id === params.value)?.name}</p>
      ),
    },
    {
      field: "amountOrNumberOfSets",
      headerName: `${isTabBeforeDesign ? "Amount" : "No. of Payments"}`,
      flex: 1,
    },
    {
      field: "intervalByDays",
      headerName: "Interval By Days",
      flex: 0.6,
    },
  ];

  if (isTabBeforeDesign) {
    columns.pop();
  }

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>Payment Schedule</DialogTitle>
        <DialogContent dividers>
          Mode of Payment: {modeOfPayment?.name}
          <StyledDataGrid autoHeight rows={schedule} columns={columns} />
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={onClose} theme="green">
            Close
          </StyledButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ShowScheduleDialog;
